import { clearAuthScopedCaches } from '@/composables/useAuthScopedCaches'

interface VersionInfo {
  version: string
  buildTime: string
}

/** Version of the deployed build from `/version.json`; null when unreachable (dev server, offline). */
export async function fetchDeployedVersion(): Promise<string | null> {
  try {
    const response = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return null
    const info: VersionInfo = await response.json()
    return info.version
  } catch {
    return null
  }
}

/**
 * Moves this tab onto the deployed build, landing on `destination`: per-user
 * caches are purged, then a full load fetches the shell from the network.
 */
export async function applyAppUpdate(destination: string): Promise<void> {
  await clearAuthScopedCaches().catch(() => {})
  window.location.assign(destination)
}
